import React from 'react';
import { Route } from 'react-router-dom';
import Dimensions from './Dimensions';

const DimensionsRoute = ({ features, bodyTypes }) => {
  return (
    <Route
      path="/config/dimensions/:id"
      render={({ match, history }) => {
        const id = match.params.id;
        return (
          <Dimensions
            onClose={() => {
              history.push('/config');
            }}
            features={features}
            id={id}
            bodyTypes={bodyTypes}
          />
        );
      }}
    />
  );
};

export default DimensionsRoute;
